import { render, staticRenderFns } from "./CandidateSidebarLoader.vue?vue&type=template&id=3f95b511&scoped=true"
import script from "./CandidateSidebarLoader.vue?vue&type=script&lang=js"
export * from "./CandidateSidebarLoader.vue?vue&type=script&lang=js"
import style0 from "./CandidateSidebarLoader.vue?vue&type=style&index=0&id=3f95b511&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f95b511",
  null
  
)

export default component.exports